import { Injectable } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { NgxHttpClientExtraOptions } from 'ngx-httpclient';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ValidationDiscountService {
  /**
   * @description constructor
   * @params http
   */
  constructor(
    private http: HttpClient
  ) {
    this.http = http;
  }
  /**
   * @description validar descuento
   * @params code
   */
  getCheckValidationCode(code: string): Observable<ArrayBuffer> {

    const httpOpt: NgxHttpClientExtraOptions | any = {
      headers: new HttpHeaders()
        .append('Content-Type', 'application/json')
    };
    const obj: any = { codDescuento: code };
    httpOpt.params = new HttpParams({ fromObject: obj });

    return this.http.get(
      environment.endpoints.urlBase +
      environment.endpoints.descuentoValidar.name,
      httpOpt
    );
  }
}
